function html_slide_thumb(data) {
  return '<div class="slide_preview">' +
    '<img src="' + data.thumb + '" alt="preview">' +
    '</div>';
}

function slick_prev(name) {
  if (name) {
    return (
      '<button type="button" class="slick-prev"><svg class="svg-icon ' +
      name +
      '"><use xlink:href="' + baseUrl + 'img/sprite.svg#' +
      name +
      '"></use></svg></button>'
    );
  } else {
    return '<button type="button" class="slick-prev"></button>';
  }
}

function slick_next(name) {
  if (name) {
    return (
      '<button type="button" class="slick-next"><svg class="svg-icon ' +
      name +
      '"><use xlink:href="' + baseUrl + 'img/sprite.svg#' +
      name +
      '"></use></svg></button>'
    );
  } else {
    return '<button type="button" class="slick-next"></button>';
  }
}

function resize_text(el, length, size) {
  if (el.text().length > length) {
    el.css('font-size', size + 'px');
  }
}

function adaptive_font_size(el) {

  $(el).each(function() {
    var text = $(this);
    var window_width = $(window).outerWidth();

    if (window_width >= 768) {
      resize_text(text, 30, 35);
    }

    if (window_width <= 480) {
      resize_text(text, 20, 14);
    }

  });
}